/**
 * Service for displaying dialog (modal) messages
 * */

import { Injectable } from '@angular/core'
import { GbFrontDialogService } from '../gb-front-dialog-service/gb-front-dialog.service'
import { GbMessageDialogComponent } from './gb-message-dialog.component'
import { GbDialogConfig, GbDialogData } from './message-data.models'

@Injectable({
  providedIn: 'root',
})
export class GbMessageDialogService {
  constructor(private gbFrontDialogService: GbFrontDialogService) {}

  /** *
   *
   * showDialog() shows the dialog
   *
   * @param title title, default ''
   * @param body body, default ''
   * @param messageType type of message to display, default 'message'
   * @param activityFeed hide / show the activity feed options, default false
   * @param mobileFullScreen make dialog fullscreen on mobile, default true
   * */

  showDialog(data: GbDialogData): void {
    const defaultDialogData: GbDialogData = {
      activityFeed: false,
      mobileFullScreen: true,
      messageType: 'message',
      item: null,
      payment: false,
      eventTicket: false,
    }

    const dialogData = { ...defaultDialogData, ...data }

    const dialogClasses: string[] = []

    switch (dialogData.messageType) {
      case 'success':
        dialogClasses.push('gb-success-dialog')
        break
      case 'warning':
        dialogClasses.push('gb-warning-dialog')
        break
      case 'message':
        dialogClasses.push('gb-message-dialog')
        break
    }

    dialogData.mobileFullScreen ? dialogClasses.push('mobile-dialog-full-screen') : null

    const dialogConfig: GbDialogConfig = {
      panelClass: dialogClasses,
      data: dialogData,
      autoFocus: false,
    }

    this.gbFrontDialogService.openDialog(GbMessageDialogComponent, dialogConfig)
  }
}
